export const NotificationType = Object.freeze({
  Service: 'service',
  Campaign: 'campaign',
  InactivtyService: 'inactivity-service',
  Property: 'property',
});
